import React, { useState } from 'react'
import styles from './TeacherSignup.module.scss'
import routes from '../../../routes'
import { useHistory } from 'react-router-dom'
import Button from '../../Button';
import Typography from "../../Typography";
import SchoolAsyncSelect from '../../admin/Forms/SchoolAsyncSelect'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'

const TeacherSignup = () => {
  const [email, setEmail] = useState('');
  const [schoolId, setSchoolId] = useState();
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault()

    setSubmitting(true);

    const axiosInstanceRemote = axios.create({
      baseURL: '/',
    })

    const params = { school_id: schoolId, email: email };
    axiosInstanceRemote
      .post('users/generate_otp', params)
      .then((response) => {
        if (response.data.status === 200) {
          history.push(routes.teacherLoginCode(params))
        } else {
          setSubmitting(false);
          toast("There was an error finding your account. Please make sure your email includes your district's email domain.",
            { type: 'error' })
        }
      })
      .catch((e) => {
        console.log(e)
        setSubmitting(false);
        toast("There was an error finding your account. Please make sure your email includes your district's email domain.",
          { type: 'error' })
      })
  }

  return (
    <div className={styles.page}>
      <ToastContainer position="bottom-left" />

      <form className={styles.form} onSubmit={handleSubmit}>
        <Typography align="center" tag="h1" weight="bold">
          Please select your school and enter your email
        </Typography>

        <Typography align="center" tag="p">
          A verification code will be sent to the email address you provide
        </Typography>

        <hr />

        <label>
          School
          <SchoolAsyncSelect
            name='Search School'
            valueField="name"
            placeholder="Select school"
            setValue={setSchoolId}
          />
        </label>

        <label>
          Email
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)} />
        </label>

        <Button fullWidth type="submit" variant="primary" disabled={submitting}>
          Continue
        </Button>
      </form>
    </div>
  )
}

export default TeacherSignup;
